<template>
  <div>
    <div class="content-box">
      <div class="row">
        <div class="col-lg-9">
          <div class="element-wrapper">
            <div class="element-box">
              <h5 class="form-header">
                Abono #
                <u>{{ current.numero }}</u>
                &nbsp;
                <div
                  class="badge"
                  :class="{
                    'badge-success': current.estado == 'A',
                    'badge-warning': current.estado == 'B',
                    'badge-danger': current.estado == '9',
                    'badge-dark': current.estado == 'Z',
                  }"
                >
                  <i class="os-icon os-icon-ui-09"></i>
                  <span v-if="current.estado_str">{{
                    current.estado_str
                  }}</span>
                  <span v-if="!current.estado_str">En Proceso</span>
                </div>
                <div class="st-meta float-right">
                  <div class="element-actions">
                    <div class="btn-group">
                      &nbsp; &nbsp;
                      <button
                        aria-expanded="false"
                        aria-haspopup="true"
                        class="btn btn-secondary dropdown-toggle"
                        data-toggle="dropdown"
                        type="button"
                      >
                        <i class="fa fa-cogs"></i>
                        Acciones
                      </button>
                      <div class="dropdown-menu dropdown-menu-right">
                        <button
                          class="dropdown-item"
                          @click="abrir"
                          :disabled="!(current.estado == 'B')"
                          href="#"
                        >
                          <i class="fa fa-unlock"></i>
                          Abrir Operación
                        </button>
                        <button
                          class="dropdown-item"
                          @click="cerrar"
                          :disabled="!(current.estado == 'A')"
                          href="#"
                        >
                          <i class="fa fa-lock"></i>
                          Cerrar Operación
                        </button>
                        <!-- <button
                          class="dropdown-item"
                          @click="anular"
                          :disabled="!(current.estado != '9')"
                          href="#"
                        >
                          <i class="fa fa-archive"></i>
                          Anular Operación
                        </button> -->
                        <div class="dropdown-divider"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="st-meta float-right">
                  <div class="element-actions">
                    <div class="btn-group">
                      <button
                        @click="refreshCurrent()"
                        class="btn btn-sm btn-info"
                      >
                        <i class="fas fa-sync"></i> Actualizar Info.
                      </button>
                      <button
                        aria-expanded="false"
                        aria-haspopup="true"
                        class="btn btn-secondary dropdown-toggle"
                        data-toggle="dropdown"
                        type="button"
                      >
                        <i class="fa fa-print"></i>
                        Imprimir
                      </button>
                      <div class="dropdown-menu dropdown-menu-right">
                        <button
                          class="dropdown-item"
                          @click="imprimir(current)"
                          :disabled="!current.estado == 'A'"
                          v-if="
                            current.devolucionclienteeabonoe_set &&
                            current.devolucionclienteeabonoe_set[0]
                          "
                        >
                          <i class="f far fa-file-pdf"></i>
                          Imprimir NC
                        </button>
                        <button
                          class="dropdown-item"
                          v-if="
                            current &&
                            current.abono_serie &&
                            current.abono_serie.cxc_tipo_abono == 'RC'
                          "
                          @click="imprimirTicket()"
                          :disabled="!(current.estado !== 'A')"
                        >
                          <i class="far fa-file-pdf"></i>
                          Imprimir recibo ticket
                        </button>
                        <div class="dropdown-divider"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </h5>
              <small
                v-if="current.errors && current.errors.detail"
                class="form-text text-danger"
                >{{ current.errors.detail }}</small
              >
              <hr />
              <h6 class="text-success font-weight-bold">
                <u>Información General</u>
              </h6>
              <hr />
              <br />
              <div class="row">
                <div class="col-sm-3">
                  <div class="form-group">
                    <label>Serie</label>
                    <input
                      v-if="current.abono_serie"
                      type="text"
                      :disabled="true"
                      v-model="current.abono_serie.serie"
                      class="form-control"
                    />
                  </div>
                </div>
                <div class="col-sm-3">
                  <div class="form-group">
                    <label>Cuenta Bancaria</label>
                    <input
                      v-if="current.cuenta_bancaria"
                      type="text"
                      :disabled="true"
                      v-model="current.cuenta_bancaria.nombre"
                      class="form-control"
                    />
                  </div>
                </div>
                <div class="col-sm-3">
                  <div class="form-group">
                    <label>Tipo Abono</label>
                    <input
                      v-if="current.abono_serie"
                      type="text"
                      :disabled="true"
                      v-model="current.abono_serie.cxc_tipo_abono"
                      class="form-control"
                    />
                  </div>
                </div>
                <div class="col-sm-3">
                  <div class="form-group">
                    <label>Fecha</label>
                    <input
                      v-if="current.fecha"
                      type="text"
                      :disabled="true"
                      v-model="current.fecha"
                      class="form-control"
                    />
                  </div>
                </div>
                <div class="col-sm-3">
                  <div class="form-group">
                    <label>Nit de cliente</label>
                    <input
                      v-if="current.cliente"
                      type="text"
                      :disabled="true"
                      v-model="current.cliente.nit"
                      class="form-control"
                    />
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="form-group">
                    <label>Nombre de cliente</label>
                    <input
                      v-if="current.cliente"
                      type="text"
                      :disabled="true"
                      v-model="current.cliente.nombre"
                      class="form-control"
                    />
                  </div>
                </div>
                <div class="col-sm-3">
                  <div class="form-group">
                    <label>Tienda</label>
                    <input
                      v-if="current.tienda"
                      type="text"
                      :disabled="true"
                      v-model="current.tienda.nombre"
                      class="form-control"
                    />
                  </div>
                </div>
              </div>
              <div class="os-tabs-w mx-4">
                <div class="os-tabs-controls">
                  <ul class="nav nav-tabs">
                    <li class="nav-item">
                      <a
                        aria-expanded="false"
                        class="nav-link active"
                        data-toggle="tab"
                        href="#home"
                      >
                        Detalle de Pago</a
                      >
                    </li>
                    <li class="nav-item">
                      <a
                        aria-expanded="false"
                        class="nav-link"
                        data-toggle="tab"
                        href="#menu1"
                      >
                        Contabilización</a
                      >
                    </li>
                    <li class="nav-item">
                      <a
                        aria-expanded="false"
                        class="nav-link"
                        data-toggle="tab"
                        href="#menu2"
                      >
                        Aplicación</a
                      >
                    </li>
                  </ul>
                </div>
                <div class="tab-content">
                  <div id="home" class="container tab-pane active">
                    <table class="table table-bordered table-striped">
                      <thead>
                        <tr>
                          <th>Forma Pago</th>
                          <th class="text-center">Total</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="detalle in current.cxcabonod_set"
                          v-bind:key="detalle.id"
                        >
                          <td v-if="!detalle.numero_cheque">
                            {{ detalle.forma_pago }}
                          </td>
                          <td v-if="detalle.numero_cheque">
                            {{ detalle.forma_pago }} -
                            {{ detalle.numero_cheque }}
                          </td>
                          <td
                            class="text-right bolder nowrap"
                            style="font-weight: 500"
                          >
                            <span class="text-rigth"> {{ detalle.total }}</span>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <div></div>
                  </div>
                  <div id="menu1" class="container tab-pane fade">
                    <div class="table-responsive" v-if="current.id != null">
                      <table class="table table-bordered table-striped">
                        <thead>
                          <tr>
                            <th>Cuenta Contable</th>
                            <th>Centro Costo</th>
                            <th class="text-center">Fecha</th>
                            <th class="text-center">Abono</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="detalle in current.cxcabonocontab_set"
                            v-bind:key="detalle.id"
                          >
                            <td>{{ detalle.cuenta_contable.nombre }}</td>
                            <td>{{ detalle.centro_costo.nombre }}</td>
                            <td>{{ detalle.fecha }}</td>
                            <td>{{ detalle.abono }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                  <div id="menu2" class="container tab-pane fade">
                    <div class="table-responsive" v-if="current.id != null">
                      <table class="table table-bordered table-striped">
                        <thead>
                          <tr>
                            <th>Numero</th>
                            <th>Serie</th>
                            <th class="text-center">Fecha</th>
                            <th class="text-center">Serie Fel</th>
                            <th class="text-center">Numero Fel</th>
                            <th class="text-center">total Aplicado</th>
                            <th class="text-center">total Pendiente</th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="detalle in current.cxcaplicacionabonocargo_set"
                            v-bind:key="detalle.id"
                          >
                            <td>{{ detalle.cargo.numero }}</td>
                            <td>{{ detalle.cargo.cargo_serie }}</td>
                            <td>{{ detalle.cargo.fecha }}</td>
                            <td>{{ detalle.cargo.serie_fel }}</td>
                            <td>{{ detalle.cargo.numero_fel }}</td>
                            <td>{{ detalle.cargo.total_aplicado }}</td>
                            <td>{{ detalle.cargo.total_pendiente }}</td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>

              <div class="form-buttons-w">
                <router-link
                  class="btn btn-dark"
                  :to="{ name: 'cxc-abonos-fel' }"
                >
                  <i class="fa fa-arrow-circle-left"></i>
                  Pendientes de FEL
                </router-link>
              
                <router-link
                  class="btn btn-warning"
                  :to="{ name: 'cxc-abonos' }"
                >
                  Ver Todos los Abonos
                  <i class="fa fa-link"></i>
                </router-link>
              </div>
            </div>
          </div>
        </div>
        <div class="col-3">
          <div class="element-wrapper">
            <div class="element-box">
              <h6 v-if="current.uuid_fel || current.contingencia_fel">
                Datos Fel
              </h6>
              <div v-if="current.uuid_fel || current.contingencia_fel">
                <span v-if="current.uuid_fel">UUID:</span>
                <span class="badge text-success" v-if="current.uuid_fel">
                  {{ current.uuid_fel }}
                </span>
                <br />
                <button
                  @click="enviarFel(current)"
                  class="btn btn-sm btn-primary btn-block"
                  v-if="
                    current.uuid_fel == null && current.contingencia_fel != null
                  "
                >
                  Enviar Fel
                </button>
                <span v-if="current.uuid_fel">No.:</span>
                <span class="badge text-success" v-if="current.uuid_fel">
                  {{ current.numero_fel }}
                </span>
                <br />
                <span v-if="current.uuid_fel">Serie:</span>
                <span class="badge text-success" v-if="current.uuid_fel">
                  {{ current.serie_fel }}
                </span>
                <h6
                  class="text-danger"
                  v-if="
                    current.uuid_fel == null && current.contingencia_fel != null
                  "
                >
                  Fel Esta Pendiente de envío
                </h6>
              </div>
              <hr />
              <div class="form-group text-right">
                <small><label>Valor Total</label></small>
                <h4 class="text-right">
                  <span class="text-info">Q{{ current.total }}</span>
                </h4>
              </div>
              <div class="form-group text-right">
                <small><label>Total Aplicado</label></small>
                <h4 class="text-right">
                  <span class="text-success"
                    >Q {{ current.total_aplicado }}</span
                  >
                </h4>
              </div>
              <div class="form-group text-right">
                <small><label>Total Pediente</label></small>
                <h4 class="text-right">
                  <span class="text-dark">Q{{ current.total_pendiente }}</span>
                </h4>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AbonosService from "@/services/cxc/AbonosService";
import Notifications from "@/notifications/notifications";
import DynamicService from "@/services/commons/DynamicService";

export default {
  components: {},
  data() {
    return {
      current: {
        id: null,
        estado_str: null,
        tienda: "",
        fecha: "01/01/2019",
        estado: "A",
        estado_str: "",
        total: "",
        cliente_nombre: "",
        cliente_nit: "",
        numero: "",
        errors: [],
        cxcabonod_set: [],
        cxcabonocontab_set: [],
        cxcaplicacionabonocargo_set: [],
      },
    };
  },
  computed: {
  },
  mounted() {
    let self = this;
    if (this.$route.params.id) {
      self.refreshCurrent();
    }
  },
  methods: {
    imprimirTicket() {
      let self = this;
      const baseApiUrl = process.env.VUE_APP_ROOT_API;
      let id = self.current.id.replace(/-/gi, "");
      window.open(
        `${baseApiUrl}/cat/reporte/?report_format=pdf&report_name=cxc/abonos/ReciboCaja_sinCobro_Media_Carta.jrxml&Id=${id}`
      );
    },
    imprimirFel(current) {
      let self = this;
      window.open(
        `https://report.feel.com.gt/ingfacereport/ingfacereport_documento?uuid=${current.uuid_fel}&formato=pdf&tipo_operacion=CERTIFICACION`
      );
    },
    imprimir(current) {
      let self = this;
      if (current.devolucionclienteeabonoe_set[0]) {
        self.devolucion =
          current.devolucionclienteeabonoe_set[0].devolucion_cliente_e.replace(
            /-/g,
            ""
          );
        const baseApiUrl = process.env.VUE_APP_ROOT_API;
        ("/cxc/abonos/notacredito/?Id=f1f4cc41-f628-4759-9035-fd97e69c3ba7&report_format=pdf");
        window.open(
          `${baseApiUrl}/cxc/abonos/notacredito/?&Id=${self.devolucion}&report_format=pdf`
        );
      }
    },
    refreshCurrent() {
      let self = this;
      AbonosService.getById(this.$route.params.id).then((response) => {
        self.current = response.data;
      });
    },
    guardar(e) {
      e.preventDefault();
      let self = this;
      self.current.cliente = self.current.cliente.nit;
      let current = Object.assign({}, self.current);
      AbonosService.save(current)
        .then((response) => {
          if (current.id == null) {
            self.$router.push({
              name: "cxc-abonos-editar",
              params: { id: response.data.id },
            });
            document.location.reload();
          }
        })
        .catch((error) => {
          self.current.errors = error.response.data;
        });
    },
    abrir() {
      let self = this;
      Notifications.alert.confirm(
        "Abonos",
        "Desea Abrir la transacción?",
        "Si Abrir",
        function () {
          AbonosService.abrir(self.current.id)
            .then((response) => {
              Notifications.alert.success(
                "Abonos",
                "Transaccion abierta puede continuar editando."
              );
              self.refreshCurrent();
            })
            .catch((error) => {
              Notifications.alert.error(
                "Abrir Transaccion",
                error.response.data.detail
              );
            });
        }
      );
    },
    cerrar() {
      let self = this;
      Notifications.alert.confirm(
        "Abonos",
        "Desea cerrar la transacción?",
        "Si Abrir",
        function () {
          AbonosService.cerrar(self.current.id)
            .then((response) => {
              Notifications.alert.success(
                "Abonos",
                "Se ha cerrado la transaccion."
              );
              self.refreshCurrent();
            })
            .catch((error) => {
              Notifications.alert.error(
                "Cerrar Transaccion",
                error.response.data.detail
              );
            });
        }
      );
    },
    anular() {
      let self = this;
      Notifications.alert.confirm(
        "Abonos",
        "Desea Anular la transacción?",
        "Si Anular",
        function () {
          AbonosService.anular(self.current.id)
            .then((response) => {
              Notifications.alert.success(
                "Abonos",
                "Se ha anulado la transaccion."
              );
              self.refreshCurrent();
            })
            .catch((error) => {
              Notifications.alert.error(
                "Anular Transaccion",
                error.response.data.detail
              );
            });
        }
      );
    },
    enviarFel(current) {
      let self = this;
      DynamicService.postAction("cxc", "abonos", current.id, "enviar_fel").then(
        (response) => {
          self.refreshCurrent();
          Notifications.alert.success(
            "Enviar abono a Fel",
            "Se ha realizado exitosamente"
          );
        }
      );
    },
  },
};
</script>
